import {useOktaAuth} from "@okta/okta-react";
import axios from "axios";
import config from "./config";
import { useMemo } from "react";

let logoutFunction;
// AI-GENERATED: Memoize authAxios so it only changes when the access token changes
/**
 * Returns a memoized axios instance with the current access token.
 * @returns {import('axios').AxiosInstance}
 */
export const useAuthConfig = () => {
    const {authState} = useOktaAuth();
    // Memoize authAxios so it only changes when the access token changes
    const authAxios = useMemo(() => axios.create({
        baseURL: config.apiBaseURI,
        headers: {
            'Authorization': `Bearer ${authState.accessToken?.accessToken}`,
            'content-type': 'application/json',
            'Accept': 'application/json'
        }
    }), [authState.accessToken?.accessToken]);
    return authAxios;
}

/**
 * Only used by pa-user-session.class
 * @param {Function} logout The function to force a logout.
 * @returns {undefined}
 */
export const setLogoutFunction = (logout) => {
    logoutFunction = logout;
}

/**
 * Only used by pa-user-session.class and the services.
 * @returns {logout}
 */
export function getLogoutFunction() {
	return logoutFunction;
}
